__turbopack_context__.v({
  "link-chip": "LinkChip-module-scss-module__E5qRIG__link-chip",
});
